import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody } from '@/shared/api/generated';

import type { HelpscoutInfo } from '../model';

type HelpscoutPath = '/v1/workspaces/{workspace_id}/helpscout';
type CreateParams = PathParams<HelpscoutPath, 'post'> &
  RequestBody<HelpscoutPath, 'post'>;

const normalizeMailboxIds = (mailbox_ids: number[] | null | undefined) => {
  if (!mailbox_ids) return null;
  return mailbox_ids.map(String);
};

/**
 * Helpscout credential 생성
 */
export const createHelpscoutInfo = async ({
  workspace_id,
  client_id,
  client_secret,
}: CreateParams): Promise<HelpscoutInfo> => {
  const res = await v1ApiClient.post(
    `/workspaces/${workspace_id}/helpscout`,
    { client_id, client_secret },
  );

  return {
    ...res.data,
    mailbox_ids: normalizeMailboxIds(
      res.data.mailbox_ids as number[] | null | undefined,
    ),
  };
};
